module.exports = __webpack_public_path__ + "img/LogoTransparent.63d0f903.png";